import { getLeFEOrigin } from '@utils/util';

export const BohriumApp = () => (
    <iframe className="admin-iframe" title="app加精" src={`${getLeFEOrigin()}/#/app/admin/bohrium_app`} />
);
